import { render, staticRenderFns } from "./AdvOrderTransportersExternal.vue?vue&type=template&id=47b0acaa&scoped=true"
import script from "./AdvOrderTransportersExternal.vue?vue&type=script&lang=js"
export * from "./AdvOrderTransportersExternal.vue?vue&type=script&lang=js"
import style0 from "./AdvOrderTransportersExternal.vue?vue&type=style&index=0&id=47b0acaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0acaa",
  null
  
)

export default component.exports